import React from 'react';
import { useSelector } from 'react-redux';

import { Badge, Button, Drawer, Popover } from '@mui/material';
import { AlertIcon } from '@sharedCR/coreDesignSystem/icons';
import PushNotificationPanel from 'app/pages/pushNotifications/PushNotificationPanel';

import { IconSize } from 'constants/coreDesignSystem';
import { PUSH_NOTIFICATION_BADGE_MAX } from 'constants/pushNotifications';
import { COLOR_PALETTE } from 'constants/ui';
import { useBreakpoints } from 'hooks/useBreakpoints';
import usePopover from 'hooks/usePopover';

import { selectPushNotificationUnreadCount } from 'store/pushNotifications/selectors';

import {
  drawerPaperProps,
  popoverAnchorOrigin,
  popoverSlotProps,
  popoverTransformOrigin,
} from './PushNotificationBell.constants';
import { iconButtonStyles } from './PushNotificationBell.styles';
import { PushNotificationBellTestIds } from './PushNotificationBell.testIds';

const PushNotificationBell = () => {
  const unreadCount = useSelector(selectPushNotificationUnreadCount);

  const { isDesktop } = useBreakpoints();

  const { anchorEl, onSetAnchorElement, onClearAnchorElement } = usePopover();

  return (
    <>
      <Button
        aria-label="Notifications"
        data-is-active={!!anchorEl}
        data-testid={PushNotificationBellTestIds.BELL}
        sx={iconButtonStyles}
        onClick={onSetAnchorElement}
      >
        <Badge badgeContent={unreadCount} color="error" max={PUSH_NOTIFICATION_BADGE_MAX}>
          <AlertIcon color={COLOR_PALETTE.GRAY[1]} size={isDesktop ? IconSize[24] : IconSize[20]} />
        </Badge>
      </Button>

      {!isDesktop && (
        <Drawer
          PaperProps={drawerPaperProps}
          anchor="right"
          data-testid={PushNotificationBellTestIds.DRAWER}
          open={!!anchorEl}
          onClose={onClearAnchorElement}
        >
          <PushNotificationPanel withBackButton onClose={onClearAnchorElement} />
        </Drawer>
      )}

      {isDesktop && (
        <Popover
          anchorEl={anchorEl}
          anchorOrigin={popoverAnchorOrigin}
          open={!!anchorEl}
          slotProps={popoverSlotProps}
          transformOrigin={popoverTransformOrigin}
          onClose={onClearAnchorElement}
        >
          <PushNotificationPanel onClose={onClearAnchorElement} />
        </Popover>
      )}
    </>
  );
};

export default PushNotificationBell;
